<template>
    <label
        class="block"
        data-spec-class="radio-box"
        :data-spec-id="`radio-box--${title.split(' ').join('-').toLowerCase()}`"
    >
        <input
            :value="modelValue"
            :name="name"
            type="radio"
            class="hidden"
            @input="$emit('update:modelValue', id)"
        />
        <div
            class="cursor-pointer rounded-sm border border-gray-400 bg-gray-600 p-3 text-left"
            :class="modelValue == id ? '!bg-blue-700' : ''"
        >
            <template v-if="badges.length">
                <div class="flex space-x-3 pb-2">
                    <template
                        v-for="badge in badges"
                        :key="badge.id"
                    >
                        <badge
                            :text="translateNameI18n(badge, 'name_i18n')"
                            :color="badge.color"
                        />
                    </template>
                </div>
            </template>
            <p class="text-white">{{ title }}</p>
            <p
                v-if="description"
                :class="['text-xs', modelValue === id ? 'text-white' : 'text-blue-700']"
            >
                {{ description }}
            </p>
            <p
                v-if="properties"
                :class="['text-xs', modelValue === id ? 'text-white' : 'text-gray-300']"
            >
                {{ properties }}
            </p>
        </div>
    </label>
</template>

<script>
import Badge from './Badge.vue';
import { getTranslation } from '../../../../utils/i18nUtils';

export default {
    components: { Badge },
    props: {
        name: { type: String, required: true },
        badges: { type: Array, default: () => [] },
        id: { type: [String, Number], required: true },
        modelValue: { type: [String, Number], default: null },
        title: { type: String, required: true },
        description: { type: String, default: '' },
        properties: { type: String, default: '' },
    },
    emits: ['update:modelValue'],
    methods: {
        translateNameI18n(badge) {
            return getTranslation(badge, 'name_i18n');
        },
    },
};
</script>
